import {
  Box,
  Card,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export const ActivityTableSkeleton = () => (
  <Box
    aria-label="Loading activity history"
    aria-busy="true"
    className="flex flex-col gap-2"
    sx={{
      "& .MuiSkeleton-root": { fontSize: "inherit", lineHeight: "inherit" },
      "& .MuiSkeleton-text": { transform: "scale(1, 0.6)" },
    }}
  >
    <TableContainer component={Card} variant="outlined" aria-hidden="true">
      <Table
        size="small"
        sx={{
          border: 0,
          "& .MuiTableCell-root": {
            px: 2,
            py: "9px",
            border: 0,
            borderBottom: 1,
            borderColor: "divider",
          },
          "& .MuiTableCell-head": {
            height: 44,
            py: 0,
            backgroundColor: "background.paper",
          },
          "& .MuiTableCell-body": { borderBottom: 0 },
        }}
      >
        <TableHead>
          <TableRow>
            {[80, 65, 70, 45].map((width) => (
              <TableCell key={width}>
                <Typography variant="caption">
                  <Skeleton width={width} />
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {["70%", "60%", "75%", "50%"].map((width) => (
              <TableCell key={width}>
                <Skeleton width={width} />
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <div aria-hidden="true" className="flex items-center justify-center gap-2">
      <Skeleton variant="circular" width={37} height={37} />
      <Typography variant="body2">
        <Skeleton width={60} />
      </Typography>
      <Skeleton variant="circular" width={37} height={37} />
    </div>
  </Box>
);
